<template>
  <b-modal
      :id="modalId"
      modal-class="p-4 big-modal"
      dialog-class="modal-lg"
      content-class="text-center pb-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      lazy
  >
    <div class="gigawhat-modal ml-3 mb-2">
      <div class="modal-heading mt-3">
        <h2 class="modal-title">Historique de l’opération</h2>
        <p class="modal-description">
          Suivi des étapes et changements de statut
        </p>
      </div>

      <div class="mr-5">
        <div class="table-scroll-wrapper">
          <div class="info-line">
            <table class="giga-table" aria-describedby="history_table">
              <thead>
              <tr style="background-color:#132d48;height:25px" class="text-white">
                <th class="text-white">Date</th>
                <th class="text-white">Ancien statut</th>
                <th class="text-white">Statut</th>
              </tr>
              </thead>
            </table>
            <div class="table-body-scroll">
              <table class="giga-table">
                <tbody>
                <tr
                    v-for="(evt, i) in history"
                    :key="i"
                    style="background-color:#ebf3fa"
                    class="cursor-pointer"
                >
                  <td><p>{{ evt.date }}</p></td>
                  <td><p>{{ evt.oldStatut }}</p></td>
                  <td><p>{{ evt.statut }}</p></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
                id="btn-leave"
                class="giga-blue_outlined_button no-icon"
                @click="hide"
            >
              Quitter
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "OperationHistorique",
  props: {
    modalId: { type: String, required: true },
    operation: { type: Object, required: true }
  },
  computed: {
    history() {
      return this.operation.history || [];
    }
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    hide() {
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
  }
};
</script>

<style scoped lang="scss">
.giga-table {
  width: 100% !important;
  th,
  td {
    padding: 8px 12px;
    text-align: left;
  }
  th:first-child, td:first-child { width: 33%; }
  th:nth-child(2), td:nth-child(2) { width: 33%; }
  th:last-child, td:last-child { width: 34%; }
}

.cursor-pointer:hover {
  background-color: #d7e8f7;
}

.table-body-scroll {
  height: 300px;
  overflow-y: auto;
  margin-top: -1px;
}

.table-scroll-wrapper thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
